module.exports = __webpack_public_path__ + "img/flag-vn.b5533955.png";